import { WebUiConfig } from '@eql-ai/typescript-types';
import { Action } from 'redux';
import { ConfigRequestStatus } from '../types';

export enum WebUiConfigActionTypes {
    SET_WEB_UI_CONFIG = 'SET_WEB_UI_CONFIG',
    SET_WEB_UI_CONFIG_REQUEST_STATUS = 'SET_WEB_UI_CONFIG_REQUEST_STATUS',
}

export interface ExtendedWebUiConfig extends WebUiConfig {
    member_verification_title: string;
    member_verification_outcome_copy: string;
    member_verification_header: string;
    member_verification_member_field: string;
    member_verification_tooltip: string;
    member_verification_error_message: string;
    member_verification_CTA: string;
    privacy_policy_template: string;
    faq_template: string;
    full_terms_template: string;
    terms_summary_template: string;
}

export interface WebUiConfigState {
    requestStatus: ConfigRequestStatus | null;
    config: ExtendedWebUiConfig | null;
    lastRequestTime: number | null;
}

export interface SetRequestStatusAction extends Action {
    type: WebUiConfigActionTypes.SET_WEB_UI_CONFIG_REQUEST_STATUS;
    payload: ConfigRequestStatus;
}
export interface SetWebUiConfigAction extends Action {
    type: WebUiConfigActionTypes.SET_WEB_UI_CONFIG;
    payload: {
        config: WebUiConfig | null;
        lastRequestTime: number | null;
    };
}

export type WebUiConfigReducerAction =
    | SetRequestStatusAction
    | SetWebUiConfigAction;
